import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function BookButton({
    testId = "book-cta",
    label = "Book a Free Consultation",
    fullWidth = false,
    variant = "primary",
    size = "md",
}) {
    const sizes = {
        sm: "px-5 py-2.5 text-xs",
        md: "px-6 py-3 text-xs",
        lg: "px-8 py-4 text-sm",
    };

    const styles =
        variant === "primary"
            ? "bg-[#D4AF37] text-black hover:bg-[#C5A059] shadow-[0_0_40px_rgba(212,175,55,0.25)] hover:shadow-[0_0_60px_rgba(212,175,55,0.5)]"
            : "bg-transparent border border-[#1a2a4a] text-white hover:border-[#1E90FF] hover:text-[#00B7FF] hover:shadow-[0_0_30px_rgba(30,144,255,0.3)]";

    return (
        <Link
            to="/book"
            data-testid={testId}
            className={`inline-flex items-center justify-center gap-2 font-bold uppercase tracking-[0.18em] transition-all duration-300 rounded-none ${
                sizes[size]
            } ${styles} ${fullWidth ? "w-full" : ""}`}
        >
            <span>{label}</span>
            <ArrowUpRight size={16} strokeWidth={2.5} />
        </Link>
    );
}
